import { gql } from '@apollo/client/core';
import UserPreview from '@/apollo/fragments/Notification/NotificationUserPreview.fragment';

const NotificationTestimonialPreview = gql`
  ${UserPreview}

  fragment TestimonialPreview on Testimonial {
    id
    requestor {
      slug
    }
    author {
      firstname
      lastname
    }
  }
`;

export default NotificationTestimonialPreview;
